import { Typography } from "@suraasa/placebo-ui"
import React from "react"

const Home = () => {
  return <Typography>Loading</Typography>
}

export default Home
